import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { ModalResponsavelComponent } from '../../modal-responsavel/modal-responsavel.component';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { ProgramaService } from '../../services/programa.service';

@Component({
  selector: 'app-programa-projeto-list',
  templateUrl: './programa-projeto-list.component.html',
  styleUrls: ['./programa-projeto-list.component.scss']
})
export class ProgramaProjetoListComponent extends BaseListComponent<ProjetoCadastro> implements OnInit, OnDestroy {

  lista: any;
  infoProjeto: ProjetoCadastro;
  idPrograma: number;

  @ViewChild("modalResonsavel") modalResonsavel: ModalResponsavelComponent;

  constructor(
    public activatedRoute: ActivatedRoute,
    public myservice: ProgramaService,
    private toastr: ToastrService,
  ) {
    super();
  }

  ngOnInit() {
    this.idPrograma = this.activatedRoute.snapshot.parent.params?.idProjeto;
    this.search();
  }


  search() {
    this.loading();
    let filtro = { filter_pg_type1: this.idPrograma };
    this.addSub(
      this.myservice.getListSearchProgramas(filtro).subscribe({
        next: (res) => {
          this.lista = res;
          this.loaded();
        },
        error: (error) => {
          this.toastr.error(error.error.message);
          this.loaded();
        },
      })
    );
  }

  view(data: any) {
    return ["/projetos/projeto/" + data.id + "/cadastro"];
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  viewResonsavel(projeto: ProjetoCadastro) {
    this.modalResonsavel.openModal([projeto, ...projeto?.resp_adj]);
  }
  hasTag(projeto, id: number,key:string){
    if(projeto[key]){
      var ids = projeto[key].split(",");
      if(projeto[key + '_pg_id']){
        ids += projeto[key + '_pg_id'].split(",");
      }
      return ids.includes(id.toString());
    }
  }

}
